(function() {
  'use strict';

  function initCard(card) {
    if (card.dataset.swatchTitleInit === 'true') return;
    card.dataset.swatchTitleInit = 'true';

    var titleEl = card.querySelector('.grid-product__title');
    if (!titleEl) return;

    var originalTitle = titleEl.textContent.trim();
    var swatches = card.querySelectorAll('.grid-product__colors .color-swatch');

    if (swatches.length === 0) return;

    swatches.forEach(function(swatch) {
      swatch.addEventListener('mouseenter', function() {
        var label = swatch.getAttribute('aria-label') || '';
        // aria-label format: "Product Title - Colour Name"
        var parts = label.split(' - ');
        if (parts.length >= 2) {
          var colour = parts.slice(1).join(' - '); // handles colour names containing " - "
          titleEl.textContent = colour;
        }
      });
    });

    // When the mouse leaves the whole swatch group, restore original title
    var swatchesWrap = card.querySelector('.grid-product__colors');
    if (swatchesWrap) {
      swatchesWrap.addEventListener('mouseleave', function() {
        titleEl.textContent = originalTitle;
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.grid-product').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init for theme editor section reloads
  document.addEventListener('shopify:section:load', initAll);
})();